'use client'

import React from 'react'
import Seo from '../../components/Seo'
import FAQSection from '../../components/FAQSection'
import { globalFaqs } from '../../data/faqs/globalFaqs'
import CTA from '@/components/CTA'

const FAQPage = () => {
  const pageUrl = '/faq'

  return (
    <>
      <Seo
        title="Frequently Asked Questions – Xentovra"
        description="Find answers to common questions about Xentovra's BPO services, outsourcing solutions, and business processes."
        url={pageUrl}
        breadcrumbItems={[
          { name: 'Home', url: 'https://www.xentovra.in/' },
          { name: 'FAQ', url: 'https://www.xentovra.in/faq' },
        ]}
      />
      
      <main className="faq-page bg-light-blue">
        <div className="page-header-section">
          <h1 className="section-heading">
            Frequently Asked Questions
          </h1>
          <p className="page-description">
            Find answers to common questions about our services and solutions
          </p>
        </div>
        
        <section className="section-padding">
          <FAQSection 
            title="" 
            faqs={globalFaqs} 
            className="main-faq-section" 
          />
        </section>
        
        <CTA />
      </main>
    </>
  )
}
export default FAQPage
